import React from 'react';
import { RouteComponentProps } from '@reach/router';
import FullPage from '../../layouts/FullPage';

// TODO: Import components

interface IEditSalesProposalPageProps extends RouteComponentProps { }

interface IState { }

class EditSalesProposalPage extends React.Component<IEditSalesProposalPageProps, IState> {
    // Define the constructor for the edit sales proposal page
    constructor (props: IEditSalesProposalPageProps) {
        // Pull in parent props
        super(props);
    }

    // TODO: When the component mounts
    componentDidMount () {
    }

    // Render the TSX for the edit sales proposal container
    render () {
        return (
            <FullPage>
                Edit Sales Proposal page
            </FullPage>
        );
    }
}

export default EditSalesProposalPage;
